import ReadWriteLockExternal from "rwlock";

import { LockHandle } from "./LockHandle";

export class Lock {
    private readonly lock: ReadWriteLockExternal;

    public constructor() {
        this.lock = new ReadWriteLockExternal();
    }

    public acquire(): Promise<LockHandle> {
        return new Promise<LockHandle>(resolve => {
            this.lock.writeLock(releaseCallback => {
                resolve(new LockHandle(releaseCallback));
            });
        });
    }
}
